import store from '@/store';
import { computed } from 'vue';

const latitud = computed(() => store.state.projectLAT)
const longitud = computed(() => store.state.projectLNG)
const zoom = computed(() => store.state.projectZOOM)

const APIKEYGOOGLEMAPS = computed(() => {
    return {
        api: `${process.env.VUE_APP_MAP_API_KEY}`,
        center: { lat: latitud, lng: longitud },
        zoom: zoom.value,
        cenNew: [latitud, longitud]
    }
})

export default {
    APIKEYGOOGLEMAPS,
    latitud,
    longitud,
    zoom,
}